// src/ui/wizard.js - Two-step wizard for mobile

export function createWizardForm() {
  const container = document.createElement("div");
  container.className = "lior-booking-wizard";
  
  // Step 1: Date & Time
  const step1 = document.createElement("div");
  step1.className = "lior-booking-wizard-step";
  step1.setAttribute("data-step", "1");
  
  const step1Title = document.createElement("h3");
  step1Title.className = "lior-booking-wizard-title";
  step1Title.textContent = "מתי נוח לך?";
  
  const dateTimeRow = document.createElement("div");
  dateTimeRow.className = "lior-booking-form-row-2";
  
  const dateWrapper = document.createElement("label");
  dateWrapper.className = "lior-booking-form-field";
  const dateSpan = document.createElement("span");
  dateSpan.textContent = "תאריך";
  const dateInput = document.createElement("input");
  dateInput.type = "date";
  dateInput.name = "date";
  dateInput.required = true;
  dateWrapper.appendChild(dateSpan);
  dateWrapper.appendChild(dateInput);
  
  const timeWrapper = document.createElement("label");
  timeWrapper.className = "lior-booking-form-field";
  const timeSpan = document.createElement("span");
  timeSpan.textContent = "שעה";
  const timeInput = document.createElement("input");
  timeInput.type = "time";
  timeInput.name = "time";
  timeInput.required = true;
  timeWrapper.appendChild(timeSpan);
  timeWrapper.appendChild(timeInput);
  
  dateTimeRow.appendChild(dateWrapper);
  dateTimeRow.appendChild(timeWrapper);
  
  const step1Button = document.createElement("button");
  step1Button.type = "button";
  step1Button.className = "lior-booking-submit";
  step1Button.textContent = "המשך לפרטים";
  
  // Wrap button in container for mobile styling
  const step1ButtonContainer = document.createElement("div");
  step1ButtonContainer.className = "lior-booking-wizard-buttons";
  step1ButtonContainer.appendChild(step1Button);
  
  step1.appendChild(step1Title);
  step1.appendChild(dateTimeRow);
  step1.appendChild(step1ButtonContainer);
  
  // Step 2: Name, Phone, Notes
  const step2 = document.createElement("div");
  step2.className = "lior-booking-wizard-step";
  step2.setAttribute("data-step", "2");
  step2.style.display = "none";
  
  const step2Title = document.createElement("h3");
  step2Title.className = "lior-booking-wizard-title";
  step2Title.textContent = "פרטי יצירת קשר";
  
  const nameWrapper = document.createElement("label");
  nameWrapper.className = "lior-booking-form-field";
  const nameSpan = document.createElement("span");
  nameSpan.textContent = "שם מלא";
  const nameInput = document.createElement("input");
  nameInput.type = "text";
  nameInput.name = "name";
  nameInput.required = true;
  nameInput.placeholder = "לדוגמה: נועה לוי";
  nameWrapper.appendChild(nameSpan);
  nameWrapper.appendChild(nameInput);
  
  const phoneWrapper = document.createElement("label");
  phoneWrapper.className = "lior-booking-form-field";
  const phoneSpan = document.createElement("span");
  phoneSpan.textContent = "טלפון";
  const phoneInput = document.createElement("input");
  phoneInput.type = "tel";
  phoneInput.name = "phone";
  phoneInput.required = true;
  phoneInput.placeholder = "050-0000000";
  phoneInput.pattern = "^[0-9+\\-\\s]{6,}$";
  phoneWrapper.appendChild(phoneSpan);
  phoneWrapper.appendChild(phoneInput);
  
  const notesWrapper = document.createElement("label");
  notesWrapper.className = "lior-booking-form-field";
  const notesSpan = document.createElement("span");
  notesSpan.textContent = "הערות";
  const notesInput = document.createElement("textarea");
  notesInput.name = "note";
  notesInput.rows = 3;
  notesInput.placeholder = "פרטי תור נוספים";
  notesWrapper.appendChild(notesSpan);
  notesWrapper.appendChild(notesInput);
  
  const step2Buttons = document.createElement("div");
  step2Buttons.className = "lior-booking-wizard-buttons";
  
  const backButton = document.createElement("button");
  backButton.type = "button";
  backButton.className = "lior-booking-secondary";
  backButton.textContent = "חזרה";
  
  const submitButton = document.createElement("button");
  submitButton.type = "button";
  submitButton.className = "lior-booking-submit";
  submitButton.textContent = "אישור התור";
  
  step2Buttons.appendChild(backButton);
  step2Buttons.appendChild(submitButton);
  
  step2.appendChild(step2Title);
  step2.appendChild(nameWrapper);
  step2.appendChild(phoneWrapper);
  step2.appendChild(notesWrapper);
  step2.appendChild(step2Buttons);
  
  container.appendChild(step1);
  container.appendChild(step2);
  
  let currentStep = 1;
  // Use same breakpoint as CSS (600px)
  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  
  function showStep(step) {
    if (!isMobile) return;
    if (step === 1) {
      step1.style.display = "flex";
      step2.style.display = "none";
      currentStep = 1;
    } else {
      step1.style.display = "none";
      step2.style.display = "flex";
      currentStep = 2;
      setTimeout(() => nameInput.focus(), 100);
    }
  }
  
  if (isMobile) {
    step1Button.addEventListener("click", () => {
      if (dateInput.value && timeInput.value) {
        showStep(2);
      } else {
        dateInput.reportValidity();
        timeInput.reportValidity();
      }
    });
    
    backButton.addEventListener("click", () => {
      showStep(1);
    });
  }
  
  function getFormData() {
    const data = {
      name: nameInput.value.trim() || "",
      phone: phoneInput.value.trim() || "",
      date: dateInput.value || "",
      time: timeInput.value || ""
    };
    const note = notesInput.value.trim();
    if (note) {
      data.note = note;
    }
    return data;
  }
  
  function reset() {
    dateInput.value = "";
    timeInput.value = "";
    nameInput.value = "";
    phoneInput.value = "";
    notesInput.value = "";
    if (isMobile) {
      showStep(1);
    } else {
      step1.style.display = "flex";
      step2.style.display = "flex";
    }
  }
  
  // If desktop, show all fields at once
  if (!isMobile) {
    step1.style.display = "flex";
    step2.style.display = "flex";
    step2Title.textContent = "פרטי יצירת קשר";
    step2Buttons.removeChild(backButton);
    submitButton.style.width = "100%";
    step1ButtonContainer.remove();
  } else {
    // On mobile, ensure step1 is visible initially
    step1.style.display = "flex";
    step2.style.display = "none";
  }
  
  return {
    container,
    form: step2, // For form submission
    submitButton,
    getFormData,
    reset,
    showStep
  };
}

